<form autocomplete="off" #form="ngForm" *ngIf="prestation && isLoaded">
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.reglesGestion.remboursement.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="isRemboursable"
                                  name="isRemboursable"
                                  [ngModel]="isRemboursable"
                                  [(customModel)]="isRemboursable"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.remboursable"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.remboursement.autoriser">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="quantiteObligatoire"
                                  name="quantiteObligatoire"
                                  [ngModel]="prestation.quantiteObligatoire"
                                  [(customModel)]="prestation.quantiteObligatoire"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.quantiteObligatoire"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.remboursement.zoneObligatoire"
                                  [disabled]="!prestation.unite?.idUnite">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="type"
                                  name="type"
                                  [(ngModel)]="prestation.type"
                                  [selectOptions]="listeTypes"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="type"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.type.title"
                                  (onChange)="onTypeChange()"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="quantiteModifiable"
                                  name="quantiteModifiable"
                                  [ngModel]="prestation.quantiteModifiable"
                                  [(customModel)]="prestation.quantiteModifiable"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.quantiteModifiable"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.remboursement.autoriserModification"
                                  [disabled]="!prestation.unite?.idUnite">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="unite"
                                  name="unite"
                                  [(ngModel)]="prestation.unite"
                                  [selectOptions]="listeUnite"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="idUnite"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.unite"
                                  (onChange)="onUniteChange()"
                                  [required]="prestation.type == TypePrestation.FORFAIT || prestation.type == TypePrestation.PLAFOND">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="quantiteDefaut"
                                  name="quantiteDefaut"
                                  [(ngModel)]="prestation.quantiteDefaut"
                                  customType="number"
                                  rCol="1"
                                  [max]="999.99"
                                  [nbDecimales]="2"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.valeurDefaut"
                                  [disabled]="!prestation.unite?.idUnite">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="domainePresta"
                                  name="domainePresta"
                                  [(ngModel)]="selectedDomainePrestation"
                                  [selectOptions]="listeDomainePrestation"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="id"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.domainePresta"
                                  (onChange)="onDomainePrestationChange()"
                                  [required]="true"
                                  [disabled]="prestation.type == TypePrestation.REEL">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="prorataRemboursement"
                                  name="prorataRemboursement"
                                  [(ngModel)]="prestation.prorataRemb"
                                  customType="number"
                                  rCol="1"
                                  [max]="999.99"
                                  [nbDecimales]="2"
                                  suffix="%"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.prorataRemboursement"
                                  [disabled]="!(prestation.type == TypePrestation.REEL || (prestation.type == TypePrestation.FORFAIT && prestation.typeBareme == TypeBareme.SANS))">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="bareme"
                                  name="bareme"
                                  [(ngModel)]="prestation.typeBareme"
                                  [selectOptions]="listeBaremes"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="id"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.bareme.title"
                                  [required]="true"
                                  [postTooltipNio]="isBaremeWithSelection ? {content: 'admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.tooltip' | translate,icon: 'assignment',onClick: openBaremePopin.bind(this)} : undefined"
                                  (onChange)="onBaremeChange()"
                                  [disabled]="prestation.type != TypePrestation.FORFAIT || !(prestation.unite?.typeDistance == TypeDistance.TYPE_DISTANCE_KM || prestation.unite?.typeDistance == TypeDistance.TYPE_DISTANCE_MILES)">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="dateApplication"
                                  name="dateApplication"
                                  [ngModel]="prestation.dateApplication"
                                  [(customModel)]="prestation.dateApplication"
                                  customType="date"
                                  rCol="2"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.dateApplication"
                                  [disabled]="prestation.type == TypePrestation.REEL || selectedDomainePrestation?.id != 0 || prestation.typeBareme != TypeBareme.SANS"
                                  [required]="(prestation.type == TypePrestation.FORFAIT || prestation.type == TypePrestation.PLAFOND) && selectedDomainePrestation?.id == 0">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="montant"
                                  name="montant"
                                  [(ngModel)]="prestation.montant"
                                  customType="montant"
                                  nbDecimales="2"
                                  [montantDevise]="prestation.devise"
                                  [listeDevise]="listeDevises"
                                  rCol="3"
                                  libelle="admin.frais.prestations.detail.reglesGestion.remboursement.montantUnitaire"
                                  (onDeviseChange)="onDeviseChange($event)"
                                  [disabled]="prestation.type == TypePrestation.REEL || prestation.typeBareme != TypeBareme.SANS || selectedDomainePrestation?.id != 0"
                                  [required]="(prestation.type == TypePrestation.FORFAIT || prestation.type == TypePrestation.PLAFOND) && selectedDomainePrestation?.id == 0">
                    </custom-input>
                    <button *ngIf="isShowMontantButton()" mat-icon-button (click)="onOpenMontant()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.reglesGestion.controles.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="frequence"
                                  name="frequence"
                                  [(ngModel)]="prestation.quantiteAutorisee"
                                  customType="number"
                                  rCol="2"
                                  [nbDecimales]="3"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.frequence.title">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="frequence2"
                                  name="frequence2"
                                  [(ngModel)]="prestation.frequenceAutorisee"
                                  [selectOptions]="listeFrequences"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="id"
                                  rCol="2"
                                  [required]="true">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="cumul"
                                  name="cumul"
                                  [(ngModel)]="selectedCumul"
                                  [selectOptions]="listeCumul"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="display"
                                  optionValue="idCumul"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  [addElementClick]="addCumulClick"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.cumul.title"
                                  (onChange)="onCumulChange()"
                                  [required]="true"
                                  [disabled]="prestation.type != TypePrestation.PLAFOND">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="imputationTR"
                                  name="imputationTR"
                                  [ngModel]="prestation.imputationTR"
                                  [(customModel)]="prestation.imputationTR"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.imputationTr.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.controles.imputationTr.libelle">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="deplafonnement"
                                  name="deplafonnement"
                                  [ngModel]="prestation.disableDeplaf"
                                  [(customModel)]="prestation.disableDeplaf"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.deplafonnement.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.controles.deplafonnement.libelle"
                                  [disabled]="prestation.type != TypePrestation.PLAFOND">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="justificatif"
                                  name="justificatif"
                                  [ngModel]="prestation.pieceJointeObligatoire"
                                  [(customModel)]="prestation.pieceJointeObligatoire"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.justificatif.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.controles.justificatif.libelle">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="numerotation"
                                  name="numerotation"
                                  [ngModel]="prestation.justificatifObligatoire"
                                  [(customModel)]="prestation.justificatifObligatoire"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.numerotation.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.controles.numerotation.libelle">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="presence"
                                  name="presence"
                                  [ngModel]="prestation.justificatifDefaut"
                                  [(customModel)]="prestation.justificatifDefaut"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.presence.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.controles.presence.libelle">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="enseigne"
                                  name="enseigne"
                                  [(ngModel)]="prestation.libelleJustificatif"
                                  customType="input"
                                  maxlength="20"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.enseigne">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="enseigneCheckbox"
                                  name="enseigneCheckbox"
                                  [ngModel]="prestation.libelleJustificatifObligatoire"
                                  [(customModel)]="prestation.libelleJustificatifObligatoire"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.enseigneCheckbox.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.controles.enseigneCheckbox.libelle">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="remarque"
                                  name="remarque"
                                  [(ngModel)]="prestation.libelleRemarque"
                                  customType="input"
                                  maxlength="20"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.remarque">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="remarqueCheckbox"
                                  name="remarqueCheckbox"
                                  [ngModel]="prestation.remarqueObligatoire"
                                  [(customModel)]="prestation.remarqueObligatoire"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.controles.remarqueCheckbox.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.controles.remarqueCheckbox.libelle">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.reglesGestion.distancier.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="geolocalisation"
                                  name="geolocalisation"
                                  [ngModel]="prestation.geolocalisation"
                                  [(customModel)]="prestation.geolocalisation"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.distancier.geolocalisation.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.distancier.geolocalisation.libelle"
                                  (onChange)="onGeolocationChange()"
                                  [disabled]="prestation.unite?.typeDistance == TypeDistance.TYPE_DISTANCE_NONE">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="trajetPerso"
                                  name="trajetPerso"
                                  [ngModel]="prestation.saveTrajet"
                                  [(customModel)]="prestation.saveTrajet"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.distancier.trajetPerso.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.distancier.trajetPerso.libelle"
                                  [disabled]="!prestation.geolocalisation">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="gestionEtapes"
                                  name="gestionEtapes"
                                  [ngModel]="prestation.gestionEtapes"
                                  [(customModel)]="prestation.gestionEtapes"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.distancier.gestionEtapes.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.distancier.gestionEtapes.libelle"
                                  (onChange)="onGestionEtapesChange()"
                                  [disabled]="!prestation.geolocalisation">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="gestionHeuresGlobale"
                                  name="gestionHeuresGlobale"
                                  [ngModel]="prestation.gestionTempsGlobale"
                                  [(customModel)]="prestation.gestionTempsGlobale"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.distancier.gestionHeuresGlobale.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.distancier.gestionHeuresGlobale.libelle"
                                  (onChange)="onGestionTempsGlobaleChange()"
                                  [disabled]="!prestation.gestionEtapes">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="etapesPerso"
                                  name="etapesPerso"
                                  [ngModel]="prestation.etapesPersonnelles"
                                  [(customModel)]="prestation.etapesPersonnelles"
                                  customType="checkbox"
                                  rCol="6"
                                  libelle="admin.frais.prestations.detail.reglesGestion.distancier.etapesPerso.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.distancier.etapesPerso.libelle"
                                  [disabled]="!prestation.gestionEtapes">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="gestionHeuresDetaillee"
                                  name="gestionHeuresDetaillee"
                                  [ngModel]="prestation.gestionTempsDetaillee"
                                  [(customModel)]="prestation.gestionTempsDetaillee"
                                  customType="checkbox"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.distancier.gestionHeuresDetaillee"
                                  [disabled]="!prestation.gestionTempsGlobale">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.reglesGestion.invitations.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="usage"
                                  name="usage"
                                  [(ngModel)]="prestation.genre"
                                  [selectOptions]="listeUsage"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="code"
                                  libelle="admin.frais.prestations.detail.reglesGestion.invitations.usage.title"
                                  (onChange)="onGenreChange()"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="compteInvitesExternes"
                                  name="compteInvitesExternes"
                                  [(ngModel)]="selectedCompteExterne"
                                  [selectOptions]="listeCompteExterne"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="numero"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  [addElementClick]="addCompteExterneClick"
                                  libelle="admin.frais.prestations.detail.reglesGestion.invitations.compteInvitesExternes"
                                  (onChange)="onCompteExterneChange()"
                                  [required]="true"
                                  [disabled]="prestation.genre == Genre.STANDARD">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="gestionInvites"
                                  name="gestionInvites"
                                  [(ngModel)]="prestation.modeParticipant"
                                  [selectOptions]="listeModeParticipant"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="code"
                                  libelle="admin.frais.prestations.detail.reglesGestion.invitations.gestionInvites.title"
                                  [required]="true"
                                  [disabled]="prestation.genre == Genre.STANDARD">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="participationDepense"
                                  name="participationDepense"
                                  [ngModel]="prestation.participation"
                                  [(customModel)]="prestation.participation"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.invitations.participationDepense.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.invitations.participationDepense.libelle"
                                  [disabled]="prestation.genre == Genre.STANDARD">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.reglesGestion.taxes.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="domaineTaxe"
                                  name="domaineTaxe"
                                  [(ngModel)]="selectedDomaineTaxe"
                                  [selectOptions]="listeDomaineTaxe"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="idDomaine"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  libelle="admin.frais.prestations.detail.reglesGestion.taxes.domaineTaxe"
                                  (onChange)="onDomaineTaxeChange()"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="editionMontant"
                                  name="editionMontant"
                                  [ngModel]="prestation.saisieTaxe"
                                  [(customModel)]="prestation.saisieTaxe"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.reglesGestion.taxes.editionMontant.title"
                                  postLibelle="admin.frais.prestations.detail.reglesGestion.taxes.editionMontant.libelle"
                                  [disabled]="selectedDomaineTaxe?.idDomaine == 0">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="domaineAlternatif"
                                  name="domaineAlternatif"
                                  [(ngModel)]="selectedDomaineAlternatif"
                                  [selectOptions]="listeDomaineTaxe"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="idDomaine"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  libelle="admin.frais.prestations.detail.reglesGestion.taxes.domaineAlternatif"
                                  (onChange)="onDomaineAlternatifChange()"
                                  [required]="true"
                                  [disabled]="selectedDomaineTaxe?.idDomaine == 0">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
</form>